var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpcomingAppointment = function SvgUpcomingAppointment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "0C8CF8FE-0E3E-40A9-A3DB-5CD9A5F01205")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "08.-All-Users",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08.00_AllUser_1.2",
    transform: "translate(-1200.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(240.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(20.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Postal-Code-Copy-6",
    transform: "translate(940.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,13.5 C20.484,13.5 22.5,15.516 22.5,18 C22.5,20.484 20.484,22.5 18,22.5 C15.516,22.5 13.5,20.484 13.5,18 C13.5,15.516 15.516,13.5 18,13.5 Z M8,2 L8,4 L16,4 L16,2 L18,2 L18,4 L19,4 C20.05,4 20.9177686,4.82004132 20.9944872,5.85130541 L21,6 L21.000963,12.8032504 C20.1182253,12.2923955 19.093259,12 18,12 C14.6862915,12 12,14.6862915 12,18 C12,19.5371282 12.5780225,20.939252 13.5285648,22.0008689 L5,22 C3.94045455,22 3.08136364,21.1799587 3.00545361,20.1486946 L3,20 L3.01,6 C3.01,4.95 3.81181818,4.0822314 4.85012303,4.00551277 L5,4 L6,4 L6,2 L8,2 Z M18,15 C17.6203042,15 17.306509,15.2821539 17.2568466,15.6482294 L17.25,15.75 L17.25,19.5 L20,19.5 C20.4142136,19.5 20.75,19.1642136 20.75,18.75 C20.75,18.3703042 20.4678461,18.056509 20.1017706,18.0068466 L20,18 L18.75,18 L18.75,15.75 C18.75,15.3357864 18.4142136,15 18,15 Z M9,11 L7,11 L7,13 L9,13 L9,11 Z M13,11 L11,11 L11,13 L13,13 L13,11 Z M19,7 L5,7 L5,9 L19,9 L19,7 Z",
    id: "Combined-Shape",
    fill: "#AD5E99"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpcomingAppointment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upcoming-appointment.2f70aec3.svg";
export { ForwardRef as ReactComponent };